import { servicesContent } from "@/app/content/landingContent";

export function ServicesGrid() {
  return (
    <section
      id="services"
      className="py-20 md:py-24 px-6 bg-white"
      aria-labelledby="services-heading"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 max-w-3xl">
          <h2
            id="services-heading"
            className="text-[clamp(1.875rem,4vw,3rem)] text-slate-900 mb-6 tracking-tight font-bold"
          >
            {servicesContent.heading}
          </h2>
          <p className="text-[clamp(1.125rem,2vw,1.25rem)] text-slate-600 max-w-prose leading-relaxed">
            {servicesContent.description}
          </p>
        </div>

        <ol
          className="border-t border-gray-200 divide-y divide-gray-200"
          aria-label="Zakres usług"
        >
          {servicesContent.items.map((service, index) => (
            <li
              key={service.id}
              className="py-8 md:py-10 grid grid-cols-1 md:grid-cols-[auto_1fr_2fr] gap-4 md:gap-10 items-start"
            >
              <span
                className="text-sm font-mono text-slate-300 tabular-nums pt-0.5 select-none"
                aria-hidden="true"
              >
                {String(index + 1).padStart(2, "0")}
              </span>

              <h3 className="text-lg font-semibold text-slate-900 leading-snug">
                {service.title}
              </h3>

              <p className="text-slate-600 leading-relaxed">
                {service.description}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
